

const STORAGE_KEY = "cart";

export const cartService = {
  // ── localStorage ─────────────────────────────────────
  load: () => {
    try {
      const raw = localStorage.getItem(STORAGE_KEY);
      return raw ? JSON.parse(raw) : [];
    } catch {
      return [];
    }
  },

  save: (items) => {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(items));
  },

  clear: () => localStorage.removeItem(STORAGE_KEY),


  // ── Logique panier ────────────────────────────────────
  add: (items, product, quantity = 1) => {
    const existing = items.find(i => i.productId === product.id);
    if (existing) {
      return items.map(i =>
        i.productId === product.id
          ? { ...i, quantity: i.quantity + quantity }
          : i
      );
    }
    return [
      ...items,
      {
        productId: product.id,
        name: product.name,
        price: product.price,
        image: product.image || "",
        category: product.category || "",
        quantity,
      },
    ];
  },

  updateQuantity: (items, productId, quantity) => {
    if (quantity <= 0) return cartService.remove(items, productId);
    return items.map(i =>
      i.productId === productId ? { ...i, quantity } : i
    );
  },

  remove: (items, productId) =>
    items.filter(i => i.productId !== productId),

  getTotal: (items) =>
    items.reduce((sum, i) => sum + i.price * i.quantity, 0),

  getCount: (items) =>
    items.reduce((sum, i) => sum + i.quantity, 0),
};
